// FET checkout product display source resolution.
//
// The product's checkout display object (title, marketing price/discount, image,
// social-proof banner, order-summary line items) can come from three places, in
// priority order:
//
//   1. An inline CMS `customProductData` entry for the cart's product SKU. This is
//      a WHOLE-ENTRY override (the entry is used as-is, DB ignored for that SKU),
//      which keeps deploys zero-risk and supports split testing.
//   2. Offer-managed display data riding on the cart payload at
//      `order_offers[].offer.checkout_display` (emitted by OfferResource). Because
//      it travels with the cart, it always matches exactly what's in the cart, at
//      page load and on every cart change.
//   3. Neither -> null, and the caller derives a default from the live cart.

export const findProductOffer = (checkoutOffer) =>
	checkoutOffer?.order_offers?.find((o) => o && o.type === 'product') ?? null;

export const resolveCustomCheckoutOfferData = ({ checkoutOffer, inlineProductData } = {}) => {
	const productOffer = findProductOffer(checkoutOffer);
	const offerSku = productOffer?.offer?.sku ?? null;

	const inline = Array.isArray(inlineProductData) ? inlineProductData : [];
	const inlineEntry = inline.find((p) => p && p.sku === offerSku) ?? null;

	if (inlineEntry) {
		return inlineEntry;
	}

	return productOffer?.offer?.checkout_display ?? null;
};
